import { Typography } from '@material-ui/core';
import {
  CalendarToday,
  Email,
  Help,
  Message,
  Person,
  ReceiptRounded,
  SchoolRounded,
  Search,
  Settings,
} from '@material-ui/icons';
import { useRouter } from '@webapps/reactjs-tech-components';
import { Notifications } from '@material-ui/icons';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import HomeIcon from '@material-ui/icons/HomeRounded';
import HomeWorkIcon from '@material-ui/icons/HomeWorkRounded';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import { useStyles } from '@webapps/styles';
import Head from 'components/Head/Head';
import Affiliations from 'components/Icons/Affiliations';
import Megaphone from 'components/Icons/Megaphone';
import CvTheque from 'components/Icons/CvTheque';
import Partenaire from 'components/Icons/Partenaire';
import Team from 'components/Icons/Team';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { matchPath } from 'react-router-dom';
import Library from 'components/Icons/Library';

import Mapimg from '../../../../../libs/styles/src/lib/assets/images/map';
import theme from './theme';
import ElectricalServices from 'components/Icons/ElectricalServices';
import EditDocument from 'components/Icons/EditDocument';

const {
  colors: { iconBackground },
} = theme;

const HeaderPage = () => {
  const [pageTitle, setPageTitle] = useState('');
  const [pageSubtitle, setPageSubtitle] = useState('');
  const [icon, setPageIcon] = useState(null);
  const { classes, global, cx } = useStyles(styles);

  const { location } = useRouter();

  const isMatchingPath = (pattern) => {
    return matchPath(location.pathname, { path: pattern, exact: true }) ? true : false;
  }

  useEffect(() => {
    switch (location.pathname) {
      /* BUSINESS ACCOUNT
      -----------------------------------------------------------------
      -----------------------------------------------------------------  */
      case ROUTES_PATH.BUSINESS_DASHBOARD:
        setPageTitle('Tableau de bord');
        setPageSubtitle('Synthèse de mon compte');
        setPageIcon(
          React.createElement(HomeIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.EDIT_Business_VITRINE:
        setPageTitle('Vitrine');
        setPageSubtitle('Personnaliser ma vitrine');
        setPageIcon(
          React.createElement(HomeWorkIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.MY_VITRINE_BUSINESS:
        setPageTitle('Vitrine');
        setPageSubtitle('La vitrine en ligne');
        setPageIcon(
          React.createElement(HomeWorkIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.BUSINESS_ANNONCES_CANDIDATS:
        setPageTitle('Emplois & Candidats');
        setPageSubtitle('Ma gestion d’offres d’emploi');
        setPageIcon(
          React.createElement(Megaphone, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.CVTHEQUE_BUSINESS:
        setPageTitle('CVthèque');
        setPageSubtitle('Candidats visibles et disponibles');
        setPageIcon(<CvTheque className={classes.iconPage} />);
        break;
      case ROUTES_PATH.BUSINESS_AFFILIATION:
        setPageTitle('Affiliations');
        setPageSubtitle('Mes candidats sélectionnés');
        setPageIcon(<Affiliations className={classes.iconPage} />);
        break;
      case ROUTES_PATH.BUSINESS_PARTNERS:
        setPageTitle('Partenaires');
        setPageSubtitle('Ma gestion partenaires');
        setPageIcon(<Partenaire className={classes.iconPage} />);
        break;
      case ROUTES_PATH.BUSINESS_TEAMS:
        setPageTitle('Equipes');
        setPageSubtitle('Ma gestion d’équipes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case ROUTES_PATH.BUSINESS_INVITE_STUDENT:
        setPageTitle('Equipes');
        setPageSubtitle('Ma gestion d’équipes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case ROUTES_PATH.BUSINESS_STUDENT_HISTORIQUE:
        setPageTitle('Equipes');
        setPageSubtitle('Ma gestion d’équipes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case ROUTES_PATH.STUDENT_PLANNING:
        setPageTitle('Planning');
        setPageSubtitle('École / Entreprise');
        setPageIcon(<CalendarToday className={classes.iconPage} />);
        break;
      case ROUTES_PATH.BUSINESS_DOCUMENT:
        setPageTitle('Documents');
        setPageSubtitle('Émis, reçus et importés');
        setPageIcon(
          React.createElement(FolderSharedIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.BUSINESS_FAQ:
        setPageTitle("Ressources");
        setPageSubtitle('Utilisation de Linkpick');
        setPageIcon(React.createElement(Library, { className: classes.iconPage }));
        break;
      case ROUTES_PATH.MAP_BUSINESS:
        setPageTitle("Recherche d'offres");
        setPageSubtitle('Emplois et formations');
        setPageIcon(<Mapimg fill="#FFFFFF" height={30} width={30} />);
        break;
      case ROUTES_PATH.BUSINESS_NOTIFICATIONS:
        setPageTitle('Notifications');
        setPageSubtitle('Vos notifications');
        setPageIcon(
          React.createElement(Notifications, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.BUSINESS_MESSAGES:
        setPageTitle('Messagerie');
        setPageSubtitle("Avec les écoles et apprenants");
        setPageIcon(
          React.createElement(QuestionAnswerIcon, {
            className: classes.iconPage,
          })
        );
        break;
      case ROUTES_PATH.BUSINESS_SETTINGS:
        setPageTitle('Paramètres');
        setPageSubtitle('Configurer les paramètres de votre compte');
        setPageIcon(
          React.createElement(Settings, { className: classes.iconPage })
        );
        break;
      /* END OF BUSINESS ACCOUNT 
      ----------------------------------------------------------------- 
      ----------------------------------------------------------------- */
      /* STUDENT ACCOUNT
      -----------------------------------------------------------------
      -----------------------------------------------------------------  */
      case ROUTES_PATH.STUDENT_DASHBOARD:
        setPageTitle('Tableau de bord');
        setPageSubtitle('Synthèse de mon compte');
        setPageIcon(
          React.createElement(HomeIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.STUDENT_PROFIL:
        setPageTitle('Profil');
        setPageSubtitle('Mon CV en ligne');
        setPageIcon(
          React.createElement(Person, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.STUDENT_CV:
        setPageTitle('CV');
        setPageSubtitle('Mon CV en ligne');
        setPageIcon(
          React.createElement(Person, { className: classes.iconPage })
        );
      case ROUTES_PATH.STUDENT_SOUSCRIPTION:
        setPageTitle('Souscriptions');
        setPageSubtitle("Mes alertes d'offres");
        setPageIcon(
          React.createElement(Email, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.STUDENT_SETTINGS:
        setPageTitle('Paramètres');
        setPageSubtitle('Configurer les paramètres de votre compte');
        setPageIcon(
          React.createElement(Settings, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.STUDENT_CANDIDATURES:
        setPageTitle('Candidatures');
        setPageSubtitle("Auprès d'écoles et d'entreprises");
        setPageIcon(
          React.createElement(FindInPageIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.STUDENT_FAVORITES:
        setPageTitle('Favoris');
        setPageSubtitle('Vos offres préférées');
        setPageIcon(
          React.createElement(FavoriteIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.STUDENT_DOCUMENTS:
        setPageTitle('Documents');
        setPageSubtitle('Émis, reçus et importés');
        setPageIcon(
          React.createElement(FolderSharedIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.MYMAP:
        setPageTitle('Rechercher des offres');
        setPageSubtitle('Emplois et formations disponibles');
        setPageIcon(<Mapimg fill="#FFFFFF" height={30} width={30} />);
        break;
      case ROUTES_PATH.ACCEPT_INVIT:
        setPageTitle("Recherche d'offres");
        setPageSubtitle('Emplois et formations');
        setPageIcon(<Mapimg fill="#FFFFFF" height={30} width={30} />);
        break;
      case ROUTES_PATH.STUDENT_NOTIFICATIONS:
        setPageTitle('Notifications');
        setPageSubtitle('Vos notifications');
        setPageIcon(
          React.createElement(Notifications, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.STUDENT_MESSAGES:
        setPageTitle('Messagerie');
        setPageSubtitle("Avec les organismes");
        setPageIcon(
          React.createElement(QuestionAnswerIcon, {
            className: classes.iconPage,
          })
        );
        break;
      case ROUTES_PATH.STUDENT_FAQ:
        setPageTitle("Ressources");
        setPageSubtitle('Utilisation de Linkpick');
        setPageIcon(React.createElement(Library, { className: classes.iconPage }));
        break;
      /* END OF STUDENT ACCOUNT 
      -----------------------------------------------------------------
      -----------------------------------------------------------------  */
      /* SCHOOL ACCOUNT
      -----------------------------------------------------------------
      ----------------------------------------------------------------- */
      case ROUTES_PATH.SCHOOL_DASHBOARD:
        setPageTitle('Tableau de bord');
        setPageSubtitle('Synthèse de mon compte');
        setPageIcon(
          React.createElement(HomeIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.EDIT_SCHOOL_VITRINE:
        setPageTitle('Vitrine');
        setPageSubtitle('Personnaliser ma vitrine');
        setPageIcon(
          React.createElement(HomeWorkIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.MY_VITRINE_SCHOOL:
        setPageTitle('Vitrine');
        setPageSubtitle('La vitrine en ligne');
        setPageIcon(
          React.createElement(HomeWorkIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.SCHOOL_FORMATIONS_CANDIDATS:
        setPageTitle('Formations & Candidats');
        setPageSubtitle("Ma gestion d'offres de formation");
        setPageIcon(
          React.createElement(Megaphone, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.CVTHEQUE_SCHOOL:
        setPageTitle('CVthèque');
        setPageSubtitle('Candidats visibles et disponibles');
        setPageIcon(<CvTheque className={classes.iconPage} />);
        break;
      case ROUTES_PATH.SCHOOL_AFFILIATION:
        setPageTitle('Affiliations');
        setPageSubtitle('Mes candidats sélectionnés');
        setPageIcon(<Affiliations className={classes.iconPage} />);
        break;
      case ROUTES_PATH.SCHOOL_CONNECTIONS:
        setPageTitle('Connections CFA');
        setPageSubtitle('Ma gestion des CFA');
        setPageIcon(<ElectricalServices className={classes.iconPage} />);
        break;
      case ROUTES_PATH.SCHOOL_PARTNERS:
        setPageTitle('Partenaires');
        setPageSubtitle('Ma gestion partenaires');
        setPageIcon(<Partenaire className={classes.iconPage} />);
        break;
      case ROUTES_PATH.SCHOOL_CLASSES:
        setPageTitle('Classes');
        setPageSubtitle('Ma gestion de classes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case ROUTES_PATH.SCHOOL_INVITE_STUDENT:
        setPageTitle('Classes');
        setPageSubtitle('Ma gestion de classes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case ROUTES_PATH.STUDENT_CLASS_HISTORIQUE:
        setPageTitle('Classes');
        setPageSubtitle('Ma gestion de classes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case ROUTES_PATH.SCHOOL_DOCUMENT:
        setPageTitle('Documents');
        setPageSubtitle('Émis, reçus et importés');
        setPageIcon(
          React.createElement(FolderSharedIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.MAP_SCHOOL:
        setPageTitle("Recherche d'offres");
        setPageSubtitle('Emplois et formations');
        setPageIcon(<Mapimg fill="#FFFFFF" height={30} width={30} />);
        break;
      case ROUTES_PATH.SCHOOL_FAQ:
        setPageTitle("Ressources");
        setPageSubtitle('Utilisation de Linkpick');
        setPageIcon(React.createElement(Library, { className: classes.iconPage }));
        break;
      case ROUTES_PATH.SCHOOL_NOTIFICATIONS:
        setPageTitle('Notifications');
        setPageSubtitle('Vos notifications');
        setPageIcon(
          React.createElement(Notifications, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.SCHOOL_MESSAGES:
        setPageTitle('Messagerie');
        setPageSubtitle("Avec les entreprises et apprenants");
        setPageIcon(
          React.createElement(QuestionAnswerIcon, {
            className: classes.iconPage,
          })
        );
        break;
      case ROUTES_PATH.SCHOOL_SETTINGS:
        setPageTitle('Paramètres');
        setPageSubtitle('Configurer les paramètres de votre compte');
        setPageIcon(
          React.createElement(Settings, { className: classes.iconPage })
        );
        break;
      /* END OF SCHOOL ACCOUNT 
      ----------------------------------------------------------------- 
      ----------------------------------------------------------------- */
      /* CFA ACCOUNT
      -----------------------------------------------------------------
      ----------------------------------------------------------------- */
      case ROUTES_PATH.MAP_CFA:
        setPageTitle("Recherche d'offres");
        setPageSubtitle('Emplois et formations');
        setPageIcon(<Mapimg fill="#FFFFFF" height={30} width={30} />);
        break;
      case ROUTES_PATH.CFA_DASHBOARD:
        setPageTitle('Tableau de bord');
        setPageSubtitle('Synthèse de mon compte');
        setPageIcon(
          React.createElement(HomeIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.CFA_ORGANISMES:
        setPageTitle('Organismes de formation');
        setPageSubtitle('Gestions des formations');
        setPageIcon(
          React.createElement(SchoolRounded, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.CFA_ACCOUNTING:
        setPageTitle('Comptabilité');
        setPageSubtitle('Gestions de la facturation');
        setPageIcon(
          React.createElement(ReceiptRounded, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.CFA_RECORDS:
        setPageTitle('Dossiers OPCO');
        setPageSubtitle('Gestions des dossiers');
        setPageIcon(
          React.createElement(FolderSharedIcon, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.CFA_SETTINGS:
        setPageTitle('Paramètres');
        setPageSubtitle('Configurer les paramètres de votre compte');
        setPageIcon(
          React.createElement(Settings, { className: classes.iconPage })
        );
        break;
      case ROUTES_PATH.CFA_CONTRACT:
        setPageTitle('Convention de formation');
        setPageSubtitle('Gestions des modèles conventions');
        setPageIcon(
          React.createElement(EditDocument, { className: classes.iconPage })
        );
        break;
    }
  }, [location.pathname]);


  /* PAGES WITH PARAMS */

  useEffect(() => {
    switch (true) {
      case isMatchingPath(ROUTES_PATH.BUSINESS_TEAMS_DETAIL):
        setPageTitle('Equipes');
        setPageSubtitle('Ma gestion d’équipes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case isMatchingPath(ROUTES_PATH.BUSINESS_STUDENT_EXCLUD):
        setPageTitle('Equipes');
        setPageSubtitle('Ma gestion d’équipes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case isMatchingPath(ROUTES_PATH.BUSINESS_STUDENT_ABANDONED):
        setPageTitle('Equipes');
        setPageSubtitle('Ma gestion d’équipes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case isMatchingPath(ROUTES_PATH.BUSINESS_VITRINE):
        setPageTitle('Vitrine');
        setPageSubtitle('La vitrine en ligne');
        setPageIcon(
          React.createElement(HomeWorkIcon, { className: classes.iconPage })
        );
        break;
      case isMatchingPath(ROUTES_PATH.SCHOOL_VITRINE):
        setPageTitle('Vitrine');
        setPageSubtitle('La vitrine en ligne');
        setPageIcon(
          React.createElement(HomeWorkIcon, { className: classes.iconPage })
        );
        break;
      case isMatchingPath(ROUTES_PATH.STUDENT_EXCLUD):
        setPageTitle('Classes');
        setPageSubtitle('Ma gestion de classes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case isMatchingPath(ROUTES_PATH.STUDENT_ABANDONED):
        setPageTitle('Classes');
        setPageSubtitle('Ma gestion de classes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
      case isMatchingPath(ROUTES_PATH.SCHOOL_CLASSES_DETAIL):
        setPageTitle('Classes');
        setPageSubtitle('Ma gestion de classes');
        setPageIcon(<Team className={classes.iconPage} />);
        break;
    }
  }, [location.pathname]);

  return (
    <div>
      <Head subtitle={pageSubtitle} title={pageTitle} />
      <div className={classes.titlePage}>
        <div className={classes.blocIcon}>{icon && icon}</div>
        <div className={classes.titlebloc}>
          <div className={global.headerTitle}>{pageTitle}</div>
          <div className={global.headerSubTitle}>{pageSubtitle}</div>
        </div>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  titlePage: {
    display: 'flex',

    // marginBottom: spacing(5),
  },
  titlebloc: {
    marginLeft: spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  blocIcon: {
    background: iconBackground,
    width: 45,
    height: 45,
    // width: 80,
    // height: 80,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    '@media (max-width:768px)': {
      width: 70,
      height: 70,
      minHeight: 70,
      minWidth: 70,
    },
  },
  iconPage: {
    color: 'white',
    fontSize: 30,
  },
});

HeaderPage.propTypes = {
  icon: PropTypes.elementType,
  subTitle: PropTypes.string,
  title: PropTypes.string,
};

export default HeaderPage;
